import React, { useEffect } from "react"

function Embed({ policy }) {
  useEffect(() => {
    const script = document.createElement("script")

    script.innerHTML = `(function(d, s, id) {
      var js, tjs = d.getElementsByTagName(s)[0];
      // if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs.parentNode.insertBefore(js, tjs);
      }(document, 'script', 'termly-jssdk'));`

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <section data-slice="Embed">
      {policy === "Terms" && (
        <div className="wrapper">
          <div style={{ marginLeft: -30, marginRight: -30 }}>
            <div
              name="termly-embed"
              data-id="943ba8df-26f7-41cd-935b-fe97bdd7f0e3"
              data-type="iframe"
            />
          </div>
        </div>
      )}
      {policy === "Privacy" && (
        <div className="wrapper">
          <div style={{ marginLeft: -30, marginRight: -30 }}>
            <div
              name="termly-embed"
              data-id="5a29bbb3-d053-439c-90fa-e80c3e901828"
              data-type="iframe"
            />
          </div>
        </div>
      )}
    </section>
  )
}

export default Embed
